// extracted by mini-css-extract-plugin
export default {"footerButtonsWrapper":"changeInternalProjectNumber_footerButtonsWrapper__bP6Nh","popupWrapper":"changeInternalProjectNumber_popupWrapper__E9CtQ"};